/* --------------------------------------------------------------------------------------
   activity.component.js
   Copyright © 2021 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const activityComponent = {
  template: `
  <div xw-alert display="vm.display" class="loading-indicator" on-close="vm.onClose()">
    <div class="center-activity">
      <div xw-activity></div>
    </div>
    <p class="white-text">{{vm.label}}</p>
    <p ng-if="vm.subtitle" class="activity-subtitle">{{vm.subtitle}}</p>
  </div>
  `,
  controllerAs: 'vm',
  bindings: {
    label: '@',
    display: '=',
    onClose: '&',
    subtitle: '@'
  }
}



// WEBPACK FOOTER //
// ./src/app/common/components/activity.component.js